module.exports = __webpack_public_path__ + "img/img-63.f805ae68.png";